import { render, staticRenderFns } from "./SignatureStatusList.vue?vue&type=template&id=020b2e25"
import script from "./SignatureStatusList.vue?vue&type=script&lang=ts"
export * from "./SignatureStatusList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports